module.exports = __webpack_public_path__ + "img/layer_assoc.93bb9d37.jpg";